import { render } from "./Detail.vue?vue&type=template&id=49d4d1ae"
import script from "./Detail.vue?vue&type=script&lang=ts"
export * from "./Detail.vue?vue&type=script&lang=ts"
script.render = render

export default script